import React, { useState } from 'react';
import { CircularProgress, TextField } from '@mui/material';
import { Autocomplete as MuiAutocomplete } from '@mui/material';
import parse from 'autosuggest-highlight/parse';
import match from 'autosuggest-highlight/match';
import _ from 'lodash';

interface IAutocomplete {
    doSearch: (value: string, etag: number) => Promise<IAutocompleteResponse> | IAutocompleteResponse,
    onChange: (value: any) => void,
    value: any,
    size?: "medium" | "small"
    variant?: "standard" | "filled" | "outlined" | undefined
    inputLabel?: string
    multiple?: boolean
    disabled?: boolean
}

export interface IAutocompleteResponse {
    items: any
    etag: number
}

let Autocomplete = (props: IAutocomplete) => {
    let [isLoading, setLoading] = useState(false);
    let [open, setOpen] = useState(false);
    let [options, setOptions] = useState<{ label: string, value: string }[]>([]);

    let [eTag, setEtag] = useState<number>(0);

    let startSearch = _.debounce((e: any, searchTerm: string, reason: string) => {
        if (reason === "input")
            doSearch(searchTerm)
    }, 500);

    let doSearch = async (searchTerm: string) => {
        setLoading(true)

        setEtag(eTag + 1)

        let response = await props.doSearch(searchTerm, eTag);
        let items = response?.items ?? [];

        if (items && (response?.etag ?? 0) === eTag)
            setOptions(items);

        setOpen(true);
        setLoading(false);
    }

    let onChangeText = (value: any) => {
        props.onChange(value)
    }



    return (
        <MuiAutocomplete
            size={props.size}
            options={options}
            value={props.value.value !== 0 ? props.value : null}
            loading={isLoading}
            disabled={props.disabled}
            clearOnEscape
            open={open}
            multiple={props.multiple === true}
            onClose={() => {
                setOpen(false);
                setOptions([]);
            }}
            onInputChange={startSearch}
            noOptionsText="Nessun risultato trovato"
            filterOptions={options => options}
            onChange={(e: any, value: any) => onChangeText(value)}
            getOptionLabel={option => option?.label || ""}
            renderOption={(muiProps, option, { inputValue }) => {
                let matches = match(option.label, inputValue);
                let parts = parse(option.label, matches);

                return (
                    <li {...muiProps}>
                        <div>
                            {parts.map((part: any, index: number) => (
                                <span key={index} style={{ fontWeight: part.highlight ? 700 : 400 }}>
                                    {part.text}
                                </span>
                            ))}
                        </div>
                    </li>
                )
            }}
            renderInput={params => (
                <TextField
                    {...params}
                    label={props.inputLabel ? props.inputLabel : ""}
                    variant={props.variant || "outlined"}
                    size={props.size}
                    InputProps={{
                        ...params.InputProps,
                        className: "",
                        endAdornment: isLoading && <CircularProgress color="inherit" size={20} />
                    }}
                />
            )}
        />
    );
};

export default Autocomplete;
